import { IllustrationBox } from "./illustration/Box";
import { IllustrationCloud } from "./illustration/Cloud";
import { IllustrationCreditCard } from "./illustration/CreditCard";
import { IllustrationDocument } from "./illustration/Document";
import { IllustrationMail } from "./illustration/Mail";
import { IllustrationMap } from "./illustration/Map";
import { IllustrationShip } from "./illustration/Ship";
import IllustrationIcon, { type EmptyStateIllustrationIconProps } from "./IllustrationIcon";
import Root, { type EmptyStateRootProps } from "./Root";

export const EmptyState = {
  Root,
  IllustrationIcon,
  IllustrationBox,
  IllustrationCloud,
  IllustrationCreditCard,
  IllustrationDocument,
  IllustrationMail,
  IllustrationShip,
  IllustrationMap,
};

export const EmptyStateRoot = Root;
export const EmptyStateIllustrationIcon = IllustrationIcon;
export const EmptyStateIllustrationBox = IllustrationBox;
export const EmptyStateIllustrationCloud = IllustrationCloud;
export const EmptyStateIllustrationCreditCard = IllustrationCreditCard;
export const EmptyStateIllustrationDocument = IllustrationDocument;
export const EmptyStateIllustrationMail = IllustrationMail;
export const EmptyStateIllustrationShip = IllustrationShip;
export const EmptyStateIllustrationMap = IllustrationMap;

export type { EmptyStateIllustrationIconProps, EmptyStateRootProps };
